import { render, staticRenderFns } from "./PolicyDiscLdg.vue?vue&type=template&id=ee156232&"
import script from "./PolicyDiscLdg.vue?vue&type=script&lang=js&"
export * from "./PolicyDiscLdg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports